import {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
} from "@/components/ui/command";
import type { CommandPaletteResult, CommandPaletteScope } from "../types";

interface CommandPaletteDialogProps {
  open: boolean;
  scope: CommandPaletteScope;
  query: string;
  isLoading: boolean;
  results: CommandPaletteResult[];
  onOpenChange: (open: boolean) => void;
  onQueryChange: (value: string) => void;
  onSelectResult: (result: CommandPaletteResult) => void;
}

export function CommandPaletteDialog({
  open,
  scope,
  query,
  isLoading,
  results,
  onOpenChange,
  onQueryChange,
  onSelectResult,
}: CommandPaletteDialogProps) {
  const inputPlaceholder =
    scope === "project" ? "Search entities in this project..." : "Search projects...";

  const emptyMessage = isLoading
    ? "Loading search data..."
    : scope === "project"
      ? "No matching entities or clarifications"
      : "No matching projects";

  return (
    <CommandDialog
      open={open}
      onOpenChange={onOpenChange}
      className="!top-[25vh] w-[96vw] !max-w-[768px] !translate-y-0"
      title="Command Palette"
      description="Search projects and entities"
    >
      <Command shouldFilter={false} className="p-2">
        <CommandInput
          autoFocus
          value={query}
          onValueChange={onQueryChange}
          placeholder={inputPlaceholder}
          className="text-sm"
        />
        <CommandList className="max-h-[32rem] px-1 pb-2 pt-1">
          <CommandEmpty>{emptyMessage}</CommandEmpty>
          {results.map((result) => {
            const Icon = result.icon;
            return (
              <CommandItem
                key={result.id}
                value={result.id}
                onSelect={() => onSelectResult(result)}
                className="min-h-9 gap-2.5 px-3 py-2"
              >
                <Icon className="size-4 text-muted-foreground" />
                <p className="min-w-0 flex-1 truncate text-sm font-medium">{result.label}</p>
                <CommandShortcut className="max-w-[9rem] truncate text-[0.6875rem] tracking-normal text-muted-foreground">
                  {result.typeLabel}
                </CommandShortcut>
              </CommandItem>
            );
          })}
        </CommandList>
      </Command>
    </CommandDialog>
  );
}
